import {
  ArrowDropDown,
  Assessment,
  Description,
  MoreVert,
  Payment,
  People,
} from '@mui/icons-material';
import {
  Avatar,
  Button,
  Card,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
} from '@mui/material';
import { useState } from 'react';

interface Plan {
  subscribe_rate_id: string;
  fixed_value: string;
  marketing_title: string;
  marketing_description: string;
  feature: string[];
  days_of_trail_period: number;
  chargeusers: any;
}

const ClientPortal = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [clients] = useState([
    // Mock data
    {
      client: 'John Doe',
      address: '123 Main St',
      businessName: 'ACME Corp',
      coverage: 'Full',
      expiration: '2023-12-31',
      premium: '$1200',
      premiumTrend: 'up',
      status: 'Active',
      statusColor: 'green',
      actionLabel: 'Edit',
    },
  ]);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='flex flex-col lg:flex-row'>
      <Drawer variant='permanent' anchor='left' classes={{ paper: 'w-full lg:w-64 bg-surface-raised' }}>
        <div className='p-4'>
          <h2 className='text-xl font-bold'>Client Portal</h2>
        </div>
        <List>
          {[
            { icon: <People />, text: 'Dashboard' },
            { icon: <Description />, text: 'My Quotes' },
            { icon: <Assessment />, text: 'Reports' },
            { icon: <Payment />, text: 'Billing' },
          ].map((item, index) => (
            <ListItem button key={index}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <div className='flex-1 p-6 bg-surface' style={{ minHeight: '100vh', minWidth: '100vh' }}>
        {/* Header */}
        <div className='flex flex-col lg:flex-row items-center justify-between gap-4'>
          <div>
            <h2 className='text-2xl font-semibold'>Hi Jacob Dominic</h2>
            <p className='text-foreground-muted'>Here’s all your clients</p>
          </div>
          <div className='flex items-center gap-4'>
            <Avatar src='https://via.placeholder.com/32' />
            <div>
              <p className='font-medium'>Jacob D</p>
              <p className='text-sm text-foreground-muted'>jacobd...@gmail.com</p>
            </div>
            <ArrowDropDown />
          </div>
        </div>

        {/* Stats */}
        <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6'>
          <Card className='p-4 shadow'>
            <h3 className='text-lg font-semibold'>$948</h3>
            <p className='text-foreground-muted'>Money transfer using bank</p>
          </Card>
          <Card className='p-4 shadow'>
            <h3 className='text-lg font-semibold'>$145.5</h3>
            <p className='text-foreground-muted'>Premium this month</p>
          </Card>
          <Card className='p-4 shadow'>
            <h3 className='text-lg font-semibold'>14</h3>
            <p className='text-foreground-muted'>Active Clients</p>
          </Card>
        </div>

        {/* Tabs and Search */}
        <div className='flex flex-col lg:flex-row justify-between items-center mt-6'>
          <Tabs
            value={selectedTab}
            onChange={(e, value) => setSelectedTab(value)}
            className='flex-grow'
          >
            <Tab label='All' />
            <Tab label='Active' />
            <Tab label='Pending' />
            <Tab label='Drafts' />
          </Tabs>
          <div className='flex items-center gap-4 mt-4 lg:mt-0'>
            <TextField
              variant='outlined'
              size='small'
              placeholder='Search for clients, businesses'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Button variant='contained' color='primary'>
              Create New Quote
            </Button>
          </div>
        </div>

        {/* Table */}
        <TableContainer className='mt-6'>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Client</TableCell>
                <TableCell>Business Name</TableCell>
                <TableCell>Coverages</TableCell>
                <TableCell>Expiration</TableCell>
                <TableCell>Premium</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {clients.map((client, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <div>
                      <strong>{client.client}</strong>
                      <p className='text-sm text-foreground-muted'>{client.address}</p>
                    </div>
                  </TableCell>
                  <TableCell>{client.businessName}</TableCell>
                  <TableCell>{client.coverage}</TableCell>
                  <TableCell>{client.expiration}</TableCell>
                  <TableCell
                    className={`${
                      client.premiumTrend === 'up' ? 'text-green-500' : 'text-red-500'
                    }`}
                  >
                    {client.premium}
                  </TableCell>
                  <TableCell style={{ color: client.statusColor }}>{client.status}</TableCell>
                  <TableCell>
                    <Button size='small'>Details</Button>
                    <Button size='small' onClick={handleMenuClick}>
                      <MoreVert />
                    </Button>
                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                      <MenuItem onClick={handleMenuClose}>Details</MenuItem>
                      <MenuItem onClick={handleMenuClose}>Delete</MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default ClientPortal;
